import React from "react";
import PropTypes from "prop-types";

import globalStyles from "globalStyles";
import { Section, Pill } from "components";
import { comprehensions, languages, tools } from "../../data";
import {
  K_COLORS_LIGHT_GREY,
  K_COLORS_CRIMSON_RED,
  K_COLORS_DARK_NAVY,
  K_MOBILE_SIZE,
} from "constants.js";
import { useWindowSize } from "hooks";

const AboutSection = (props) => {
  const { anchorRef } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  return (
    <Section style={styles.section} anchorRef={anchorRef}>
      <h1 style={styles.title}>ABOUT ME</h1>

      <div style={styles.contentContainer}>
        <h5 style={styles.content}>
          I am a technology enthusiast and a forever learning developer - devoted to
          code inspiring and awe-striking things.
          <br />
          In addition to my engineering skills, I am also in possession of good
          social and communication skills.
          <br />
          As a dedicated worker who enjoys working in a team, I will be a good
          addition to any team I am put into.
          <br />
          I am passionate and eager to deliver high-quality work.
          <br />
        </h5>
      </div>

      <div style={styles.pillContainer}>
        {languages.map((item, index) => (
          <Pill
            primaryColor={K_COLORS_CRIMSON_RED}
            secondaryColor={K_COLORS_LIGHT_GREY}
            text={item}
            key={index}
          />
        ))}
      </div>

      <div style={styles.pillContainer}>
        {tools.map((item, index) => (
          <Pill
            primaryColor={K_COLORS_DARK_NAVY}
            secondaryColor={K_COLORS_LIGHT_GREY}
            text={item}
            key={index}
          />
        ))}
      </div>

      <div style={styles.pillContainer}>
        {comprehensions.map((item, index) => (
          <Pill
            primaryColor={K_COLORS_CRIMSON_RED}
            secondaryColor={K_COLORS_LIGHT_GREY}
            text={item}
            key={index}
          />
        ))}
      </div>
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.lightBackground,
    textAlign: "center",
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.titleSpacing,
    marginBottom: "1.5rem",
  },
  content: {
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.textNormalSize,
  },
  contentContainer: {
    margin: "2rem",
  },
  pillContainer: {
    padding: "0.25rem",
    marginTop: "1em",
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.lightBackground,
    textAlign: "center",
    paddingTop: "5rem",
    paddingBottom: "5rem",
  },
  content: {
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.textSmallerSize,
  },
  contentContainer: {
    margin: "0",
    padding: "0",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  pillContainer: {
    padding: "0.1rem",
    marginTop: "1em",
  },
  title: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.titleSpacing,
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
  },
};

AboutSection.propTypes = {
  anchorRef: PropTypes.shape().isRequired,
};

export default AboutSection;
